import {withProps} from 'recompose'

import compose from 'lodash/flowRight'
import type {ComponentType} from 'react'
import {memo} from 'react'
import {connect} from 'react-redux'

import {withBranchProps} from '../../../hooks/routes'
import type {State} from '../../../reducers/types'
import {getBuildType, getIsBuildTypePaused, getStatus} from '../../../selectors'
import {
  getBuildTypeStatusRequest,
  getPipelineStatusRequest,
  getProjectStatusRequest,
  InvestigationStates,
} from '../../../types'
import type {ProjectOrBuildTypeStatus, StatusRequest} from '../../../types'

import ProjectOrBuildTypeIcon from './ProjectOrBuildTypeIcon'
import {EntityIconType} from './ProjectOrBuildTypeIcon.types'
import type {
  OverviewStatusIconOwnProps,
  OverviewStatusIconStateProps,
} from './ProjectOrBuildTypeIcon.types'

const statusMap = {
  SUCCESS: 'successful',
  FAILURE: 'failed',
  UNKNOWN: null,
} as const

function getStatusRequest(props: OverviewStatusIconOwnProps): StatusRequest | null {
  switch (props.type) {
    case 'project':
      return props.id != null ? getProjectStatusRequest(props.id, props.branch) : null

    case 'buildType':
      return props.id != null ? getBuildTypeStatusRequest(props.id, props.branch) : null

    case 'pipeline':
      return props.id != null ? getPipelineStatusRequest(props.id, props.branch) : null

    default:
      return null
  }
}

const mapStateToProps = (
  state: State,
  props: OverviewStatusIconOwnProps,
): OverviewStatusIconStateProps => {
  const buildType = props.type === 'buildType' ? getBuildType(state, props.id) : null
  const statusObj: ProjectOrBuildTypeStatus | null | undefined = getStatus(
    state,
    getStatusRequest(props),
  )
  const statusStr = statusObj?.status
  const status = statusStr ? statusMap[statusStr] : null
  let title
  let iconItemType = props.type
  const investigation = statusObj?.investigation

  if (props.showInvestigationInStatus === true) {
    if (investigation === InvestigationStates.TAKEN) {
      title = 'Investigation is assigned'
      iconItemType = EntityIconType.INVESTIGATION
    }
  }

  const paused = props.type === 'buildType' ? getIsBuildTypePaused(state, props.id) : false

  if (paused === true) {
    title = 'Build configuration was paused'
  }

  return {
    title,
    status: props.ignoreStatus === true ? null : status,
    type: iconItemType,
    composite: buildType?.type === 'composite',
    paused,
  }
}

const OverviewStatusIcon: ComponentType<OverviewStatusIconOwnProps> = compose(
  memo,
  withBranchProps,
  withProps(({showInvestigationInStatus = false}: OverviewStatusIconOwnProps) => ({
    showInvestigationInStatus,
  })),
  connect(mapStateToProps, {}),
)(ProjectOrBuildTypeIcon)
export default OverviewStatusIcon
